import React, { useState, useEffect } from "react";

// common function
import { windWeatherStationLatLon } from "../scripts/station";
import { gustMarker } from "../scripts/gustMarker";
import { fetchingTime } from "../../../../config/fetching";

// Style sheet
import "bootstrap/dist/css/bootstrap.min.css";
import "../scss/windMap.scss";
// mapTitle sheet
import "../scss/mapTitleMap.scss";

// leaflet css
import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
import "leaflet-defaulticon-compatibility";

// Openstreetmap components
import {
  MapContainer,
  TileLayer,
  Marker,
  useMap,
  ZoomControl,
  useMapEvents,
} from "react-leaflet";
// L component
import Leaflet from "leaflet";

// Watermark
import Watermark from "../../../../resources/image/watermark.jpg";

import { getGustInformation } from "../../../service/apiWeatherInfoService";

//#region Map Watermark
const WatermarkControl = () => {
  const map = useMap();
  const watermark = map.getContainer().querySelector(".watermark");

  if (!watermark) {
    const watermark = new Leaflet.Control({ position: "bottomleft" });
    watermark.onAdd = function (map) {
      var div = Leaflet.DomUtil.create("div", "watermark");
      div.innerHTML = "<img src='" + Watermark + "' width='75' height='75'>";
      return div;
    };
    watermark.addTo(map);
    // React.useEffect(() => {

    // }, [map]);
  }

  return null;
};

//#endregion END

type Props = { enable: number; autoUpdate?: boolean };
type gustInfo_Props = { station: string; max_gust: string; time: string };

function GustMap({ enable, autoUpdate }: Props) {
  const [isMapOn, setIsMapOn] = useState<React.Key>(0);
  const [gustArray, setGustArray] = useState<Array<gustInfo_Props>>([]);
  const [time, setTime] = useState<string>("");

  const [zoomLevel, setZoomLevel] = useState<number>(11);

  const position: Leaflet.LatLngExpression = [22.35, 114.125];

  // zoom change
  const ZoomListener = () => {
    useMapEvents({
      zoomend: (event) => {
        const map = event.target;
        const zoom = map.getZoom();

        setZoomLevel(zoom);
      },
    });
    return null;
  };

  async function getFetchGustInfomation() {
    await getGustInformation()
      .then((response) => {
        return response.data.data;
      })
      .then((data) => {
        setGustArray(data);
        setTime(data[0].time);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    const fetchData = async () => {
      if (autoUpdate === true) {
        getFetchGustInfomation();
      }
    };

    getFetchGustInfomation(); // Initial fetch

    let intervalId = setInterval(() => {
      fetchData();
    }, fetchingTime);

    return () => {
      clearInterval(intervalId);
    };
  }, [autoUpdate]);

  useEffect(() => {
    setIsMapOn(enable);

    setZoomLevel(11);
  }, [enable]);

  return (
    <div className="mapContainer">
      <MapContainer
        zoom={11}
        maxZoom={12}
        minZoom={11}
        zoomControl={false}
        center={position}
        scrollWheelZoom={false}
        key={isMapOn}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <ZoomControl position="topright" />

        <WatermarkControl />

        <ZoomListener />

        {gustArray.map((item) => {
          if (item.station === "Star Ferry" && zoomLevel === 11) {
            return null;
          } else {
            return (
              <Marker
                key={"wind-" + item.station}
                position={windWeatherStationLatLon(item.station)}
                icon={gustMarker(item.max_gust)}
              />
            );
          }
        })}
      </MapContainer>

      <div className="mapDescription">
        <div>過去1小時最大陣風(km/h)</div>
        <div>
          {time.substr(4, 2)}月{time.substr(6, 2)}日 {time.substr(8, 2)}:
          {time.substr(10, 2)}更新
        </div>
      </div>
    </div>
  );
}

export default GustMap;
